import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/functions";

export { firebase as firebase };

const firebaseConfig = {
    apiKey: "AIzaSyAAkVuCXMsS8NjlziOwWXXIyuDjRsHWkgk",
    authDomain: "college.tbtfencing.com",
    databaseURL: "https://touchbytouch-b336e.firebaseio.com",
    projectId: "touchbytouch-b336e",
    storageBucket: "touchbytouch-b336e.appspot.com",
    messagingSenderId: "60901701060",
    appId: "1:60901701060:web:84181d6968af08f5cde091",
    measurementId: "G-EL8V69KHD8"
};

const fire = firebase.initializeApp(firebaseConfig);

if (window.location.hostname === "localhost") {
    // Connect Firestore to Emulator
    fire.functions().useEmulator("localhost", 5001);
}

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

export type FirebaseUser = firebase.User;

export default fire;
